import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'

import { useAppSelector } from 'src/store/hooks'
import { selectScheduledMaintenance } from 'src/v3/settings/settings.slice'

export let MaintenancePage = () => {
  let maintenance = useAppSelector(selectScheduledMaintenance)

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        gap: 3,
        p: 4,
      }}
    >
      <img src="/logo.svg" alt="logo" width="80px" />
      <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
        Scheduled Maintenance
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ textAlign: 'center', maxWidth: 480 }}
      >
        We're performing scheduled maintenance to improve your experience. We'll
        be back shortly.
      </Typography>
      {maintenance && (
        <Typography variant="body2" color="text.secondary">
          Expected back online:{' '}
          <strong>
            {dayjs(maintenance.endTime).format('ddd, MMM D [at] h:mm A')}
          </strong>
        </Typography>
      )}
    </Box>
  )
}
